module.exports = __webpack_public_path__ + "img/location.8a5f0469.svg";